export const classes = (...arg) => arg.join(" ")
